module.exports = __webpack_public_path__ + "static/media/icon_pgcode_credit_card.52988513.svg";